import type {
  TrackDifficulty,
  TrackStateMode,
  LocalTrackStatus,
  ServerTrackStatus
} from '@/types';

export const TRACK_DIFFICULTY_BLACK: TrackDifficulty = 'black';
export const TRACK_DIFFICULTY_BLUE: TrackDifficulty = 'blue';
export const TRACK_DIFFICULTY_RED: TrackDifficulty = 'red';
export const TRACK_DIFFICULTY_GREEN: TrackDifficulty = 'green';

export const TRACK_STATE_DIFFICULTY: TrackStateMode = 'difficulty';
export const TRACK_STATE_STATUS: TrackStateMode = 'status';

// Local statuses (used internally in app after transformation)
export const TRACK_STATUS_OPEN: LocalTrackStatus = 'open';
export const TRACK_STATUS_WAITING: LocalTrackStatus = 'waiting';
export const TRACK_STATUS_CLOSED: LocalTrackStatus = 'closed';

// Server statuses (used when working with API responses)
export const SERVER_TRACK_STATUS_OPEN: ServerTrackStatus = 'open';
export const SERVER_TRACK_STATUS_WAITING: ServerTrackStatus = 'waiting';
export const SERVER_TRACK_STATUS_CLOSE: ServerTrackStatus = 'close';
